<div class="cp-footer">
	<div class="cp-footer-content">
		<div class="cp-footer-content-text">
			<span>COPYRIGHT &copy; {{currentYear}} PULTEGROUP, INC.</span>
			<div *cpIfViewSize="'desktop'" class="cp-footer-divider"></div>
			<a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer" (click)="onFooterLinkClick('Privacy Policy')">PRIVACY POLICY</a>
			<div *cpIfViewSize="'desktop'" class="cp-footer-divider"></div>
			<a [href]="termsOfUseUrl" target="_blank" rel="noopener noreferrer" (click)="onFooterLinkClick('Terms of Use')">TERMS OF USE</a>
			@if (accessibilityStatementUrl) {
				<div *cpIfViewSize="'desktop'" class="cp-footer-divider"></div>
				<a [href]="accessibilityStatementUrl" target="_blank" rel="noopener noreferrer" (click)="onFooterLinkClick('Accessibility Statement')">ACCESSIBILITY STATEMENT</a>
			}
		</div>
		<div class="cp-footer-content-logos">
			<mat-icon [svgIcon]="'footer_equal_housing'"></mat-icon>
			<span class="cdk-visually-hidden">Equal Housing Lender</span>
			<a href="https://audioeye.com/" target="_blank" rel="noopener noreferrer" aria-label="Reviewed by AudioEye for accessibility" (click)="onFooterLinkClick('AudioEye Logo')">
				<mat-icon [svgIcon]="'footer_audioeye'" aria-hidden="false" title="AudioEye Logo"></mat-icon>
			</a>
		</div>
	</div>
</div>
@if ((disclaimers$ | async)) {
<div>
	@for (disclaimer of disclaimers$ | async; track disclaimer; let i = $index) {
	<p class="cp-footer-disclaimer">{{i + 1}} - {{disclaimer}}</p>
	}
</div>
}